import { Pipe, PipeTransform } from '@angular/core';
import { formatPhoneNumberValue } from 'app/global/utils';

@Pipe({ name: 'customPhoneNumber' })
export class CustomPhoneNumberPipe implements PipeTransform {
  transform(value: any, ...args: any[]) {
    return formatPhoneNumberValue(value);
  }
}
